module.exports = __webpack_public_path__ + "img/wxEmojiSprite.92f2988d.png";